export { default } from './EntityField';
